<agpr-dialog-container
    [id]="id + '.linkDialog'"
    [heading]="heading"
    (close)="cancel()"
>
    <div
        class="agpr-linkDialogContainer"
    >
        <agpr-dropdown
            [options]="availableLinkTypes"
            optionLabel="label"
            [(ngModel)]="selectedLinkType"
            label="Common.dialog.linkType.linkTo"
        ></agpr-dropdown>

        <div
            *ngIf="selectedLinkType.value === linkTypeEnum.URL"
            class="agpr-linkDialog-webAddress"
        >
            <agpr-text-input
                [placeholder]="'Common.dialog.linkType.enterURL'"
                [(ngModel)]="url"
                (blur)="validate();"
                ariaLabel="Common.dialog.linkType.enterURL"
            ></agpr-text-input>
            <agpr-form-message
                *ngIf="urlValidationError"
            >
                {{ 'Common.dialog.linkType.validURLRequired'| localize }}
            </agpr-form-message>

            <div
                *ngIf="!isLinkField"
                class="agpr-linkDialog-checkbox">
                <agpr-checkbox
                    label="Common.dialog.linkType.openInNewWindow"
                    [binary]="true"
                    [(ngModel)]="openInNewWindow"
                ></agpr-checkbox>
            </div>

            <agpr-text-input
                *ngIf="!isLinkField && enableTooltip"
                label="Common.dialog.linkType.toolTip"
                [(ngModel)]="tooltip"
            >
            </agpr-text-input>
        </div>

        <div
            *ngIf="selectedLinkType.value === linkTypeEnum.EMAIL"
            class="agpr-linkDialog-email"
        >
            <agpr-text-input
                [id]="id + '.emailAddress'"
                label="Common.dialog.linkType.emailAddress"
                [placeholder]="'Common.dialog.linkType.enterEmailAddress'"
                [(ngModel)]="email"
                (blur)="validate();"
            ></agpr-text-input>
            <agpr-form-message
                *ngIf="emailValidationError"
            >
                {{ 'Common.dialog.linkType.validEmailRequired' | localize }}
            </agpr-form-message>

            <agpr-text-input
                [id]="id + '.messageSubject'"
                label="Common.dialog.linkType.messageSubject"
                [placeholder]="'Common.dialog.linkType.enterMessageSubject'"
                [(ngModel)]="subject"
            ></agpr-text-input>

            <agpr-textarea-input
                label="Common.dialog.linkType.messageBody"
                [placeholder]="'Common.dialog.linkType.enterMessageBody' "
                [(ngModel)]="body"
            ></agpr-textarea-input>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [label]="'cancel' | localize"
            (click)="closeDialog()"
            [style]="buttonTypes.secondary"
        >
        </agpr-button>
    </ng-template>

    <ng-template #footerRight>
        <agpr-button
            [label]="'Common.dialog.linkType.removeLink' | localize"
            (click)="removeLinkFromContext()"
        >
        </agpr-button>
        <agpr-button
            [label]="'Common.dialog.linkType.insertLink' | localize"
            [style]="buttonTypes.primary"
            (click)="insertLink()"
            [disabled]="!url && !email"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
